module.exports = __webpack_public_path__ + "img/logo.dedb5a9d.png";